<template>
 <div class="">
    <masternav/>
    <br>
    <detailscomp/>
    <br>
    <mainfooter/>
 </div> 
</template>

<script>
// @ is an alias to /src
import masternav           from '@/components/masternav.vue'
import mainfooter          from '@/components/mainfooter.vue'
import detailscomp         from '@/components/DetailsComponent' 
import { mapState } from 'vuex'
export default {
  name: 'Fleet',
  components: {
    masternav,
    mainfooter,
    detailscomp
  },
  computed: {
    ...mapState('reservav2', ['viewDetails'])
  },
  mounted () {
    if(this.accionBuscar == false)
    {
      this.$router.push({path: '/'})
    }
  },
}
</script>